var a = 0;
var isDesktopDevice = $(window).width() >= 650 || !(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent))
var isMKPEnabled = ACC.config.isMKPEnabled
ACC.datatables = {

    _autoload: [
        "onlineQuotes",
        "agencyQuotes",
         ["onlineOrdersHistory", $("#onlineOrdersHistory").length > 0 && isDesktopDevice],
         ["agencyOrdersHistory", $("#agencyOrdersHistory").length > 0 && isDesktopDevice],
         ["mkpOrdersHistory", isMKPEnabled && $("#mkpOrdersHistory").length > 0 && isDesktopDevice],
        "navOrdersHistory",
        "ordersCollapse",
        ["invoicesAmds", $("#invoicesTable").length > 0 && isDesktopDevice],
        ["invoicesMkp", isMKPEnabled && $("#invoicesMkp").length > 0 && isDesktopDevice],
        "customerCatalog",
        "navInvoicesHistory"
    ],
    onlineQuotesID: '#onlineQuotes',
    agencyQuotesID: '#agencyQuotes',
    onlineOrdersHistoryID: '#onlineOrdersHistory',
    mkpOrdersHistoryID: '#mkpOrdersHistory',
    agencyOrdersHistoryID: '#agencyOrdersHistory',
    invoicesID: '#invoicesTable',
    invoicesIdMkp: '#invoicesMkp',
    onlineQuotesCurrentPageNum: 0,
    agencyQuotesCurrentPageNum: 0,
    onlineOrdersCurrentPageNum: 0,
    agencyOrdersCurrentPageNum: 0,
    mkpOrdersCurrentPageNum: 0,
    invoicesCurrentPageNum: 0,
    customerCatalogCurrentPageNum: 0,
    customerCatalogID: '#customerCatalog',
    tableRef: [],
    objectRef: {},
    savingStatus: false,
    tableChecked: [],
    objectChecked: {},
    tableRefUpdated: [],
    tableRefInitPaged: [],
    tableResponseRefs: [],
    fitredDTDatas: '',
    emptyOnlineOrders: false,
    _customerCatalogProducts: [],
    hasErrors: false,
    AJAX_CALL_FINISHED: true,

    onlineQuotes: function () {
        if ($(ACC.datatables.onlineQuotesID).length) {
            $.fn.DataTable.ext.errMode = 'none';

            $('.content-empty').show();
            var companyLink = $('.companyLink').val();
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }

            var dataTable = $(ACC.datatables.onlineQuotesID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "className": "paddingScale",
                        "targets": [0, 1, 2, 4, 5],
                        "orderable": false,
                    },
                    {
                        "targets": [1, 2, 4],
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).attr('data-cs-mask', '');
                        }
                    },
                    {
                        "className": "firstCol",
                        "targets": [1]
                    },
                    {
                        "className": "actionsCol",
                        "targets": [6],
                        "orderable": false,
                    },
                    {
                        "width": "150px",
                        "targets": [2, 4],
                    },
                    {
                        "width": "165px",
                        "targets": [3],
                    }
                ],

                "order": [[3, 'desc']],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": companyLink + "/my-quotes/onlineQuotes" + poNumberGET,
                    "dataSrc": function (json) {
                        $('.onlinesQuotes').show();

                        $('.content-empty').hide();

                        if (json.recordsTotal <= pageSize) {
                            $('#onlineOrdersHistory_paginate').hide();
                        }
                        var textcontact = $("#js-contact-text").text();
                        $.each(json.data, function (i, item) {
                            var loopLink = "";
                            var pdfLink = "";
                            var contactAgency = "<a href='' class='agency-contact js-agency default-behavior'>Contact Agency</a><div class='agency-contact-text hidden'>" + textcontact + "</div><span class='mailItem hidden'>" + item[9] + "</span>";
                            if (item[6] !== null && item[6] !== "") {
                                pdfLink = `<a href='${item[6]}' class='pdf-file' target='\"_blank\"'><svg width="35px" height="40px"><use href="#shared-epic-logo"></use></svg></a>`;
                            }

                            if (item[10] === "Exist" && item[7] !== "contactAgency") {
                                loopLink = `<a href="my-quotes/${item[1]}" class='details-quote permanent-disabled'><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_847_2947)">
									<path d="M8.54863 17.2353C3.84208 17.2302 0 13.3489 0 8.60498C0 3.856 3.83702 0 8.55874 0C13.2805 0 17.1023 3.856 17.1023 8.61512C17.1023 13.3692 13.2602 17.2404 8.55368 17.2353H8.54863ZM15.6211 8.64557C15.6413 4.70838 12.5272 1.52718 8.61435 1.49166C4.68633 1.45615 1.49639 4.6272 1.48122 8.57961C1.46606 12.532 4.63577 15.7487 8.54863 15.7538C12.4311 15.7589 15.6009 12.5726 15.6211 8.64557Z" fill="black"></path>
									<path d="M14.8677 16.2003L16.2074 14.8304C16.2983 14.9015 16.3893 14.9624 16.4652 15.0385C17.8301 16.4033 19.19 17.7681 20.5499 19.138C20.6814 19.2699 20.8128 19.4221 20.8937 19.5896C21.1111 20.0513 20.9948 20.4622 20.6055 20.7667C20.191 21.0914 19.7208 21.0863 19.3518 20.721C17.8453 19.2293 16.3641 17.7174 14.8677 16.2003V16.2003Z" fill="black"></path>
								</g>
								<defs>
									<clipPath id="clip0_847_2947">
										<rect width="21" height="21" fill="white"></rect>
									</clipPath>
								</defs>
							</svg></a>`;
                                item[1] = "<a href='" + companyLink + "/my-quotes/" + item[1] + "'>" + item[1] + " </a>";
                            }

                            if (item[7] === "contactAgency" || item[10] == null) {
                                item[6] = "<div class='actions'>" + pdfLink + loopLink + contactAgency + "</div>";
                            } else {
                                item[6] = "<div class='actions'>" + pdfLink + loopLink + "</div>";
                            }
                        });

                        return json.data;
                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });

            ACC.datatables.getCurrentPage(ACC.datatables.onlineQuotesID);
        }
    },
    agencyQuotes: function () {
        if ($(ACC.datatables.agencyQuotesID).length) {

            $.fn.DataTable.ext.errMode = 'none';
            var companyLink = $('.companyLinkAgency').val();
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }

            var dataTable = $(ACC.datatables.agencyQuotesID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "className": "paddingScale",
                        "targets": [0, 1, 2, 4, 5],
                        "orderable": false,
                    },
                    {
                        "targets": [1, 2, 4],
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).attr('data-cs-mask', '');
                        }
                    },
                    {
                        "className": "firstCol",
                        "targets": [1]
                    },
                    {
                        "className": "actionsCol",
                        "targets": [6],
                        "orderable": false,
                    },
                    {
                        "width": "150px",
                        "targets": [2, 4],
                    },
                    {
                        "width": "165px",
                        "targets": [3],
                    }
                ],
                "order": [[3, 'desc']],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": companyLink + "/my-quotes/agencieQuotes" + poNumberGET,
                    "dataSrc": function (json) {
                        $('.agenciesQuotes').show();

                        if (json.recordsTotal <= pageSize) {
                            $('#agencyOrdersHistory_paginate').hide();
                        }
                        var textcontact = $("#js-contact-texts").text();
                        $.each(json.data, function (i, item) {
                            var loopLink = "";
                            var pdfLink = "";
                            var contactAgency = "<a href='' class='agency-contact js-agency default-behavior'></a><div class='agency-contact-text hidden'>" + textcontact + "</div><span class='mailItem hidden'>" + item[9] + "</span>";
                            if (item[6] !== null && item[6] !== "") {
                                pdfLink = `<a href="` + item[6] + `" class='pdf-file' target='\"_blank\"'> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="34px" viewBox="0 0 25 34" version="1.1">
												<g id="surface1">
													<path style="fill:none;stroke-width:1;stroke-linecap:square;stroke-linejoin:miter;stroke:rgb(0%,0%,0%);stroke-opacity:1;stroke-miterlimit:4;" d="M -0.00125 -0.00103401 L 45.00125 -0.00103401 L 45.00125 45.001034 L -0.00125 45.001034 Z M -0.00125 -0.00103401 " transform="matrix(0.531915,0,0,0.723404,0.531915,0.723404)"/>
													<path style=" stroke:none;fill-rule:nonzero;fill:rgb(8.235294%,8.235294%,8.235294%);fill-opacity:1;" d="M 12.964844 9.257812 L 12.964844 20.617188 L 14.628906 18.351562 C 14.730469 18.210938 14.910156 18.210938 15.011719 18.351562 C 15.113281 18.492188 15.113281 18.734375 15.011719 18.875 L 12.875 21.777344 C 12.816406 21.859375 12.757812 21.878906 12.683594 21.878906 C 12.609375 21.878906 12.535156 21.839844 12.492188 21.777344 L 10.355469 18.875 C 10.253906 18.734375 10.253906 18.492188 10.355469 18.351562 C 10.460938 18.210938 10.636719 18.210938 10.738281 18.351562 L 12.402344 20.617188 L 12.402344 9.257812 C 12.402344 9.058594 12.523438 8.875 12.683594 8.875 C 12.847656 8.875 12.964844 9.035156 12.964844 9.257812 Z M 7.851562 24.621094 L 17.53125 24.621094 C 17.675781 24.621094 17.808594 24.460938 17.808594 24.242188 L 17.808594 20.957031 C 17.808594 20.757812 17.691406 20.574219 17.53125 20.574219 C 17.382812 20.574219 17.25 20.734375 17.25 20.957031 L 17.25 23.859375 L 8.117188 23.859375 L 8.117188 20.957031 C 8.117188 20.757812 8 20.574219 7.839844 20.574219 C 7.691406 20.574219 7.558594 20.734375 7.558594 20.957031 L 7.558594 24.242188 C 7.574219 24.460938 7.691406 24.621094 7.851562 24.621094 Z M 7.851562 24.621094 "/>
												</g>
											</svg></a>`;
                            }
                            if (item[10] === "Exist") {
                                loopLink = `<a href="${companyLink}/my-quotes/${item[1]}" class='details-quote permanent-disabled'><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_847_2947)">
									<path d="M8.54863 17.2353C3.84208 17.2302 0 13.3489 0 8.60498C0 3.856 3.83702 0 8.55874 0C13.2805 0 17.1023 3.856 17.1023 8.61512C17.1023 13.3692 13.2602 17.2404 8.55368 17.2353H8.54863ZM15.6211 8.64557C15.6413 4.70838 12.5272 1.52718 8.61435 1.49166C4.68633 1.45615 1.49639 4.6272 1.48122 8.57961C1.46606 12.532 4.63577 15.7487 8.54863 15.7538C12.4311 15.7589 15.6009 12.5726 15.6211 8.64557Z" fill="black"></path>
									<path d="M14.8677 16.2003L16.2074 14.8304C16.2983 14.9015 16.3893 14.9624 16.4652 15.0385C17.8301 16.4033 19.19 17.7681 20.5499 19.138C20.6814 19.2699 20.8128 19.4221 20.8937 19.5896C21.1111 20.0513 20.9948 20.4622 20.6055 20.7667C20.191 21.0914 19.7208 21.0863 19.3518 20.721C17.8453 19.2293 16.3641 17.7174 14.8677 16.2003V16.2003Z" fill="black"></path>
								</g>
								<defs>
									<clipPath id="clip0_847_2947">
										<rect width="21" height="21" fill="white"></rect>
									</clipPath>
								</defs>
							</svg></a>`;
                                item[1] = "<a href='" + companyLink + "/my-quotes/" + item[1] + "'>" + item[1] + " </a>";
                            }

                            if (item[7] === "contactAgency" || item[10] == null) {
                                item[6] = "<div class='actions'>" + pdfLink + loopLink + contactAgency + "</div><span class='hidden'>" + item[8] + "</span>";
                            } else {
                                item[6] = "<div class='actions'>" + pdfLink + loopLink + "</div>";

                            }

                        });
                        return json.data;

                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });

            ACC.datatables.getCurrentPage(ACC.datatables.agencyQuotesID);
        }
    },
    quoteCodePost: function () {
        $.ajax({
            type: "GET",
            url: companyLink + "/my-quotes/" + item[1] + "/fillQuoteCode/",
            success: function (response) {
                $("#subViewDiv").html(response);
            }
        });
    },
    onlineOrdersHistory: function () {

            $.fn.DataTable.ext.errMode = 'none';

            $('.content-empty').show();
            var companyLink = $('.companyLink').val();
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }

            var url = companyLink + "/onlineOrders" + poNumberGET;
            var dataTable = $(ACC.datatables.onlineOrdersHistoryID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "targets": [0, 5],
                        "orderable": false
                    },
                    {
                        "targets": [1, 2, 4],
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).attr('data-cs-mask', '');
                        }
                    }
                ],
                "order": [[3, 'desc']],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": url,
                    "complete": function (json) {
                        if (json.responseJSON) {
                            $('.amds-empty').addClass('hidden');
                        } else {
                            if ($('#active-tab').val() === "nav-amds" && $("#agencyOrdersHistory tbody").is(":empty")) {
                                $('.amds-empty').removeClass('hidden');
                            }
                        }

                    },
                    "dataSrc": function (json) {
                        $('.onlinesOrders').show();

                        $('.content-empty').hide();

                        if (json.recordsTotal <= pageSize) {
                            $('#onlineOrdersHistory_paginate').hide();
                        }
                        $.each(json.data, function (i, item) {
                            item[0] = (ACC.datatables.onlineOrdersCurrentPageNum * pageSize + i + 1) + '.';
                        });
                        return json.data;
                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });

            ACC.datatables.getCurrentPage(ACC.datatables.onlineOrdersHistoryID);
    },
    agencyOrdersHistory: function () {

            $.fn.DataTable.ext.errMode = 'none';
            var companyLink = $('.companyLinkAgency').val();
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }
            var url = companyLink + "/agencyOrders" + poNumberGET

            var dataTable = $(ACC.datatables.agencyOrdersHistoryID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "targets": [0, 5],
                        "orderable": false
                    },
                    {
                        "targets": [1, 2, 4],
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).attr('data-cs-mask', '');
                        }
                    }
                ],
                "order": [[3, 'desc']],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": url,
                    "complete": function (json) {
                        if (json.responseJSON) {
                            $('.agency-empty').addClass('hidden');
                        } else {
                            if ($('#active-tab').val() === "nav-amds" && ACC.datatables.emptyOnlineOrders) {
                                $('.amds-empty').removeClass('hidden');
                            }
                        }

                    },
                    "dataSrc": function (json) {
                        $('.agenciesOrders').show();

                        if (json.recordsTotal <= pageSize) {
                            $('#agencyOrdersHistory_paginate').hide();
                        }
                        $.each(json.data, function (i, item) {
                            item[0] = (ACC.datatables.agencyOrdersCurrentPageNum * pageSize + i + 1) + '.';
                        });
                        return json.data;
                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });

            ACC.datatables.getCurrentPage(ACC.datatables.agencyOrdersHistoryID);

    },
    mkpOrdersHistory: function () {
        if ($(ACC.datatables.mkpOrdersHistoryID).length) {

            $.fn.DataTable.ext.errMode = 'none';
            var companyLink = $('.companyLinkAgency').val();
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }
            var url = companyLink + "/mkpOrders" + poNumberGET;

            var dataTable = $(ACC.datatables.mkpOrdersHistoryID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "targets": [0],
                        "orderable": false
                    }
                ],
                "order": [[3, 'desc']],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": url,
                    "complete": function (json) {
                        if (json.responseJSON) {
                            $('.mkp-empty').addClass('hidden');
                        } else {
                            if ($('#active-tab').val() === "nav-mkp") {
                                $('.mkpOrders').addClass('hidden');
                                $('.mkp-empty').removeClass('hidden');
                            }
                            $('#mkpOrdersHistory_wrapper').addClass('hidden');
                        }

                    },
                    "dataSrc": function (json) {
                        $('.mkpOrders').show();

                        if (json.recordsTotal <= pageSize) {
                            $('#mkpOrdersHistory_paginate').hide();
                        }
                        $.each(json.data, function (i, item) {
                            item[0] = (ACC.datatables.mkpOrdersCurrentPageNum * pageSize + i + 1) + '.';
                        });
                        return json.data;
                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });
            ACC.datatables.getCurrentPage(ACC.datatables.mkpOrdersHistoryID);
        }
    },
    navOrdersHistory: function () {
        if ($('#active-tab').val() === "nav-amds") {
            $('.onlinesOrders,.agenciesOrders').removeClass('hidden');
            $('.mkpOrders').addClass('hidden');
            $('.nav-amds').addClass('active');
            $('.nav-mkp').removeClass('active');
            $('#active-tab').val('nav-amds');
            $('.page-orders #poNumber').attr('placeholder', $('.page-orders #poNumber').attr("default-placeholder"));
        } else {
            $('.onlinesOrders,.agenciesOrders').addClass('hidden');
            $('.mkpOrders').removeClass('hidden');
            $('.nav-mkp').addClass('active');
            $('.nav-amds').removeClass('active');
            $('#active-tab').val('nav-mkp');
            $('.page-orders #poNumber').attr('placeholder', $('.page-orders #poNumber').attr("placeholder-mkp"));
        }

        $(document).on('click', '.nav-amds', function () {
            $('.onlinesOrders,.agenciesOrders').removeClass('hidden');
            $('.mkpOrders').addClass('hidden');
            $('.nav-amds').addClass('active');
            $('.nav-mkp').removeClass('active');
            $('#active-tab').val('nav-amds');
            $('.page-orders #poNumber').attr('placeholder', $('.page-orders #poNumber').attr("default-placeholder"));
            $('.mkp-empty').addClass('hidden');
            if ($("#agencyOrdersHistory tbody").is(":empty") && $("#onlineOrdersHistory tbody").is(":empty")) {
                $('.amds-empty').removeClass('hidden');
            }
            if ($('#poNumber').val() !== '') {
                $('#poNumber').val('');
                $('.poNumberFilterForm').submit();
            }

        });
        $(document).on('click', '.nav-mkp', function () {
            $('.onlinesOrders,.agenciesOrders').addClass('hidden');
            $('.mkpOrders').removeClass('hidden');
            $('.nav-mkp').addClass('active');
            $('.nav-amds').removeClass('active');
            $('#active-tab').val('nav-mkp');
            $('#poNumber').attr('placeholder', $('.page-orders #poNumber').attr("placeholder-mkp"));
            $('.amds-empty').addClass('hidden');
            if ($("#mkpOrdersHistory tbody").is(":empty")) {
                $('.mkp-empty').removeClass('hidden');
            }
            if ($('#poNumber').val() !== '') {
                $('#poNumber').val('');
                $('#mkpOrdersHistory').addClass('hidden');
                $('.poNumberFilterForm').submit();
            }
        });
    },
    invoicesAmds: function () {
        $.fn.DataTable.ext.errMode = 'none';
        var poNumber = $.trim($('#poNumber').val()),
            poNumberGET = '';

        if (poNumber != "") {
            poNumberGET = "?poNumber=" + poNumber;
        }

        var companyLink = $('.companyLink').val();
        var dataTable = $(ACC.datatables.invoicesID).DataTable({
            "processing": true,
            "serverSide": true,
            "searching": false,
            "lengthChange": false,
            "pageLength": pageSize,
            "columnDefs": [
                {
                    "targets": [0, 3, 7],
                    "orderable": false
                },
                {
                    "targets": [1, 2, 5],
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).attr('data-cs-mask', '');
                    }
                }
            ],
            "info": false,
            "ajax": {
                "type": "GET",
                "complete": function (json) {
                    if (json.responseJSON) {
                        $('#invoicesTable_wrapper').removeClass('hidden');
                    } else {
                        $('#invoicesTable_wrapper').addClass('hidden');
                        $('.amds-empty').removeClass('hidden');
                    }
                },
                "url": companyLink + "/billsHistory" + poNumberGET,
                "dataSrc": function (json) {
                    if (json.recordsTotal <= pageSize) {
                        $('#invoicesTable_paginate').hide();
                    }
                    $.each(json.data, function (i, item) {
                        item[0] = (ACC.datatables.invoicesCurrentPageNum * pageSize + i + 1) + '.';
                    });

                    var emptyColumns = [];
                    if (json.data.length > 0) {
                        json.data[0].forEach(function (_, colIndex) {
                            var isEmpty = json.data.every(function (row) {
                                return row[colIndex] === null || row[colIndex].toString().trim() === '';
                            });
                            if (isEmpty) {
                                emptyColumns.push(colIndex);
                            }
                        });
                    }

                    emptyColumns.forEach(function (colIndex) {
                        dataTable.column(colIndex).visible(false);
                    });

                    return json.data;
                }
            }
        }).on('order.dt search.dt', function () {
            dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1 + ".";
            });
        });
        ACC.datatables.getCurrentPage(ACC.datatables.invoicesID);
    },

    invoicesMkp: function () {
            $.fn.DataTable.ext.errMode = 'none';
            var poNumber = $.trim($('#poNumber').val()),
                poNumberGET = '';

            if (poNumber != "") {
                poNumberGET = "?poNumber=" + poNumber;
            }

            var companyLink = $('.companyLink').val();
            var dataTable = $(ACC.datatables.invoicesIdMkp).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "targets": [0, 7, 7],
                        "orderable": false
                    },
                ],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "complete": function (json) {
                        if (json.responseJSON) {
                            $('#invoicesMkp_wrapper').removeClass('hidden');
                        } else {
                            $('#invoicesMkp_wrapper').addClass('hidden');
                            $('.tabs-title.invoices').addClass('hidden');
                        }
                    },
                    "url": companyLink + "/mkpBillsHistory" + poNumberGET,
                    "dataSrc": function (json) {
                        for (var i in json.data) {
                            if (json.data[i][7] !== '') {
                                if(json.data[i][7].startsWith('http')){
                                    json.data[i][7] = '<a href="' + json.data[i][7] + '" target=_blank><svg width="35px" height="40px"><use href="#shared-epic-logo"></use></svg></a>';
                                }else{
                                    json.data[i][7] = '<a href="' + ACC.config.encodedContextPath + '/' + json.data[i][7] + '" target=_blank><svg width="35px" height="40px"><use href="#shared-epic-logo"></use></svg></a>';
                                }
                            }
                            if (json.data[i][8] === "green") {
                                json.data[i][6] = '<span style="color:#70A489;">' + json.data[i][6] + '</span>';
                                json.data[i][1] =  json.data[i][1] + '<img src="/_ui/responsive/theme-amds/images/alert.svg" class="invisible" alt="" style="vertical-align:text-top;margin-left:10px;width:20px;">';

                            } else if (json.data[i][8] === "red") {
                                json.data[i][6] = '<b style="color:#EC2727;">' + $('#lateStatus').attr("data-late") + '</b>';
                                json.data[i][1] = json.data[i][1] + '<img src="/_ui/responsive/theme-amds/images/alert.svg" alt="" style="vertical-align:text-top;margin-left:10px;width:20px;">';
                            } else if (json.data[i][8] === "gray") {
                                json.data[i][6] = '<span style="color:#414141;">' + $('#toPayStatus').attr("data-topay") + '</span>';
                                json.data[i][1] = json.data[i][1] + '<img src="/_ui/responsive/theme-amds/images/alert.svg" class="invisible" alt="" style="vertical-align:text-top;margin-left:10px;width:20px;">';
                            } else {
                                json.data[i][6] = '<span style="color:#414141;">' + json.data[i][6] + '</span>';
                                json.data[i][1] = json.data[i][1] + '<img src="/_ui/responsive/theme-amds/images/alert.svg" class="invisible" alt="" style="vertical-align:text-top;margin-left:10px;width:20px;">';

                            }
                        }

                        if (json.recordsTotal <= pageSize) {
                            $('#invoicesMkp_paginate').hide();
                        }
                        $.each(json.data, function (i, item) {
                            item[0] = (ACC.datatables.invoicesCurrentPageNum * pageSize + i + 1) + '.';
                        });
                        return json.data;
                    }
                }
            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1 + ".";
                });
            });

            ACC.datatables.getCurrentPage(ACC.datatables.invoicesIdMkp);
    },
    navInvoicesHistory: function () {
        if ($('#active-tab').val() === "nav-amds") {
            $('.amdsInvoices').removeClass('hidden');
            $('.mkpInvoices').addClass('hidden');
            $('.nav-amds').addClass('active');
            $('.nav-mkp').removeClass('active');
            $('#active-tab').val('nav-amds');
        } else {
            $('.amdsInvoices').addClass('hidden');
            $('.mkpInvoices').removeClass('hidden');
            $('.nav-mkp').addClass('active');
            $('.nav-amds').removeClass('active');
            $('#active-tab').val('nav-mkp');
        }
        $(document).on('click', '.invoices .nav-amds', function () {
            $('.amdsInvoices').removeClass('hidden');
            $('.mkpInvoices').addClass('hidden');
            $('.nav-amds').addClass('active');
            $('.nav-mkp').removeClass('active');
            $('#active-tab').val('nav-amds');
            if ($("#invoicesTable tbody").is(":empty")) {
                $('.invoicesTable .amds-empty').removeClass('hidden');
            }
        });
        $(document).on('click', '.invoices .nav-mkp', function () {
            $('.amdsInvoices').addClass('hidden');
            $('.mkpInvoices').removeClass('hidden');
            $('.nav-mkp').addClass('active');
            $('.nav-amds').removeClass('active');
            $('#active-tab').val('nav-mkp');
        });
    },
    getCurrentPage: function (ID) {
        $(document).on('click', ID + '_wrapper .paginate_button', function () {
            var currentPageNum = 0;

            if ($(this).hasClass('previous')) {
                currentPageNum = parseInt($(this).parent().find('.paginate_button.current').text()) - 2;
            } else if ($(this).hasClass('next')) {
                currentPageNum = parseInt($(this).parent().find('.paginate_button.current').text());
            } else {
                currentPageNum = parseInt($(this).text()) - 1;
            }

            switch (ID) {
                case ACC.datatables.onlineQuotesID:
                    ACC.datatables.onlineOrdersCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.agencyQuotesID:
                    ACC.datatables.agencyQuotesCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.onlineOrdersHistoryID:
                    ACC.datatables.onlineOrdersCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.agencyOrdersHistoryID:
                    ACC.datatables.agencyOrdersCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.mkpOrdersHistoryID:
                    ACC.datatables.mkpOrdersCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.invoicesID:
                    ACC.datatables.invoicesCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.invoicesIdMkp:
                    ACC.datatables.invoicesCurrentPageNum = currentPageNum;
                    break;
                case ACC.datatables.onlineCatalogID:
                    ACC.datatables.onlineCatalogCurrentPageNum = currentPageNum;
                    break;
            }
        });
    },
    ordersCollapse: function () {
        $(document).on('click', '.page-orders .orders-title-2', function () {
            if ($("body").width() < 640) {
                if (!$(this).hasClass('opened')) {
                    $(this).addClass('opened');
                    $(this).next('.account-section-content').css("display", "block");
                } else {
                    $(this).removeClass('opened');
                    $(this).next('.account-section-content').css("display", "none");
                }
                $(this).next('.account-section-content').slideToggle();
            }
        });

        $(document).on('click', '.page-my-quotes .orders-title-2', function () {
            if ($("body").width() < 640) {
                if (!$(this).hasClass('opened')) {
                    $(this).addClass('opened');
                } else {
                    $(this).removeClass('opened');
                }

                if (!$(this).parent().hasClass('opened')) {
                    $(this).parent().addClass('opened');
                } else {
                    $(this).parent().removeClass('opened');
                }
                $(this).next('.account-section-content').slideToggle();
            }
        });

        $(window).on('resize', function () {
            if ($(window).width() > 640) {
                $('.account-section-content').removeAttr('style');
            } else {
                $('.onlinesOrders, .agenciesOrders, .page-orders .orders-title-2, .page-orders .account-section-content').removeClass('opened');
            }
        });


    },
    customerCatalog: function () {
        if ($(ACC.datatables.customerCatalogID).length) {
            $.fn.DataTable.ext.errMode = 'none';

            $('.content-empty').show();
            var companyLink = $('.companyLink').val();
            var reference = $.trim($('#idreference').val()),
                referenceGET = '';

            if (reference != "") {
                referenceGET = "?term=" + reference;
            }

            $.get(companyLink + "/customer-catalog/onlinesCatalog/all", function (json) {
                $.each(json.data, function (i, item) {
                    ACC.datatables._customerCatalogProducts.push(
                        {
                            productCode: item[2],
                            productName: item[3],
                            productReference: item[4]
                        }
                    );
                })
            });

            var dataTable = $(ACC.datatables.customerCatalogID).DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "lengthChange": false,
                "pageLength": pageSize,
                "columnDefs": [
                    {
                        "className": "paddingScale",
                        "targets": [0, 3],
                        "orderable": false,
                    },
                    {
                        "className": "firstCol",
                        "targets": [1]
                    },
                    {
                        "className": "idRef",
                        "targets": [2],
                        "orderable": false,
                    },
                    {
                        "width": "400px",
                        "targets": [3],
                    },
                    {
                        "className": "editText",
                        "targets": [4],
                        "width": "280px",
                    }
                ],
                //"order": [[ 1, 'desc' ], [ 4, 'desc' ]],
                "info": false,
                "ajax": {
                    "type": "GET",
                    "url": companyLink + "/customer-catalog/onlinesCatalog" + referenceGET,
                    "dataSrc": function (json) {
                        $('.onlinesCatalog').show();
                        $('.no-result').addClass('display-none');

                        if (json.recordsTotal <= pageSize) {
                            $('#onlineCatalog_paginate').hide();
                        }

                        var errorTextMax = $(".js-error-max-char").text();
                        var errorTextUnique = $(".js-error-unique-ref").text();

                        //when no result
                        if (json.recordsFiltered === 0) {
                            $('.no-result').removeClass('display-none');
                            json.recordsFiltered = json.recordsTotal
                        }

                        $.each(json.data, function (i, item) {

                            item[0] = '<div class="form-checkbox">\
								<input class="check js-checkbox-ref" type="checkbox" name="check">\
								<label for="checkboxRef" tabindex="1"></label>\
						  	</div>';
                            item[4] = '<div class="editContainer">\
							<div class="ref-text" data-product-code="' + item[2] + '"data-old="' + item[4] + '">' + item[4] + '</div>\
							<div class="wrapper"><input type="text" data-old="' + item[4] + '" class="edit-ref-input hidden" name="editRef"/><button class="save-ref-btn hidden" id="' + item[2] + '" >' + SaveLabel.toUpperCase() + '</button></div>\
							<div class="pk-text hidden">' + item[5] + '</div>\
							<div class="ref-errors hidden">\
							<span class="max-char-error ref-error hidden">' + errorTextMax + '</span>\
							<span class="unique-error ref-error hidden">' + errorTextUnique + '</span>\
							</div> </div> <img class="loader hidden" src="/_ui/responsive/theme-amds/images/loader.svg"  width="25px" /> \
							<div class="icon-edit js-btn-edit-ref">\
							<img src="/_ui/responsive/theme-amds/images/picto-edit.png" alt="" style="vertical-align:text-top;margin-right:10px;width:20px;">\
							</div>';
                        });
                        //	// <button class="save hidden">Save</button>

                        return json.data;
                    }
                },
                "fnDrawCallback": function (res) {
                    res.json.recordsFiltered = res.json.recordsTotal;
                    ACC.datatables.tableRefInitPaged = res.json.data;
                    $.each(ACC.datatables.tableRefInitPaged, function (key1, value1) {
                        $.each(ACC.datatables.tableResponseRefs, function (key2, value2) {
                            if (value1[2] == value2.articleRef) {
                                $("#customerCatalog tr").each(function (e, item) {
                                    var $this = $(this);
                                    if ($this.find(".idRef").text() == value2.articleRef) {
                                        $this.find(".editText .ref-text").text(value2.reference);
                                    }
                                });
                            }
                        });
                    });


                    $("tbody .idRef").each(function (cell, current) {
                        var refArticleId = $(this).text();
                        var thisRef = $(this);
                        if (ACC.datatables.tableChecked.length) {
                            var foundchecked = ACC.datatables.tableChecked.some(function (el) {
                                return el.id == refArticleId;
                            });
                            if (foundchecked) {
                                thisRef.parents("tr").find(".js-checkbox-ref").prop('checked', true);
                            }
                        }

                        if (ACC.datatables.tableRef.length) {
                            var foundEdited = ACC.datatables.tableRef.some(function (el) {
                                return el.id == refArticleId;
                            });
                            var objEdited = $.grep(ACC.datatables.tableRef, function (el, i) {
                                return el.id == refArticleId;
                            });
                            if (foundEdited) {
                                var NewValRef = objEdited[0]["newRef"];
                                thisRef.parents("tr").find(".editText .ref-text").text(NewValRef);
                            }
                        }
                    });


                    $(document).on('click', ".js-save-btn", function (e) {
                        e.preventDefault();
                        if (ACC.datatables.tableRefUpdated.length > 0 && ACC.datatables.savingStatus == false) {
                            ACC.datatables.savingStatus = true;
                            $.ajax({
                                url: ACC.config.encodedContextPath + "/customer-reference/save",
                                type: 'POST',
                                data: JSON.stringify(ACC.datatables.tableRefUpdated),
                                datatype: 'json',
                                contentType: "application/json; charset=utf-8",
                                beforeSend: function () {
                                    $(".status-saving .text-status").addClass("hidden");
                                    $(".status-saving .text-status.sending").removeClass("hidden");
                                },
                                success: function (data) {
                                    $.each(data, function (key, obj) {
                                        if (obj.isReferenceUpdated) {
                                            $(".status-saving .color-status").addClass("green");
                                            $(".status-saving .text-status").addClass("hidden");
                                            $(".status-saving .text-status.saved").removeClass("hidden");
                                            location.reload();
                                        } else {
                                            $(".status-saving .text-status").addClass("hidden");
                                            $(".status-saving .text-status.not-saving").removeClass("hidden");
                                            ACC.colorbox.open(title = "", {
                                                href: "#errorWsRefCatalog",
                                                inline: true,
                                                width: "600px",
                                                height: "400px",
                                                onClosed: function () {
                                                    location.reload();
                                                },
                                                onComplete: function () {
                                                    $(".js-btn-redirect-ws").on("click", function () {
                                                        ACC.colorbox.close();
                                                    });
                                                },
                                            });
                                        }
                                    });
                                },
                                error: function (xhr) { // if error occured
                                    console.log("error : ", xhr);
                                },

                            })
                        }
                    })

                    $(".js-checkbox-ref").change(function () {

                        var Icheck = $(this),
                            idrefchecked = $(this).parents("tr").find(".idRef").text(),
                            customerReferencePK = $(this).parents("tr").find(".pk-text").text();

                        objectChecked = {
                            id: idrefchecked,
                            name: customerReferencePK
                        }

                        if (Icheck.is(':checked')) {
                            ACC.datatables.tableChecked.push(objectChecked);
                        } else {
                            for (var i = ACC.datatables.tableChecked.length - 1; i >= 0; i--) {
                                var obj = ACC.datatables.tableChecked[i];
                                if (idrefchecked.indexOf(obj.id) > -1) {
                                    ACC.datatables.tableChecked.splice(i, 1);
                                }
                            }
                        }
                    });

                    $(".js-download-link").click(function (e) {
                        e.preventDefault();
                        var arrayRefDown = "";
                        var valRefDown = "", i = 0;
                        $.each(ACC.datatables.tableChecked, function (index, val) {
                            i += 1;
                            valRefDown = val.name;
                            if (i == 1) {
                                arrayRefDown += valRefDown;
                            } else {
                                arrayRefDown += "," + valRefDown;
                            }

                        });

                        if (ACC.datatables.tableRef.length > 0 && ACC.datatables.savingStatus == false) {

                            ACC.colorbox.open("", {
                                href: "#w-leave-page",
                                inline: true,
                                width: "560px",
                                height: "340px",
                                className: "popup-leave",
                                onComplete: function () {
                                    $(".js-refuse-save").click(function (e) {
                                        e.preventDefault();
                                        ACC.colorbox.close();
                                    });

                                    $(".js-accept-save").click(function (e) {
                                        e.preventDefault();
                                        $(".js-save-btn").trigger("click");
                                        ACC.colorbox.close();
                                    })
                                },
                                onClosed: function () {
                                }
                            });
                        } else {
                            let orderDatas = localStorage.getItem('customerCatalogFiltreddatas');
                            if (orderDatas === null) {
                                orderDatas = '&columnIndex=1&sortDirection=asc';
                            }
                            window.location = ACC.config.encodedContextPath + "/my-account/customer-catalog/export?references=" + arrayRefDown + orderDatas;
                        }
                    });
                },

            }).on('order.dt search.dt', function () {
                dataTable.column(0, {search: 'applied', order: 'applied'}).nodes().each(function (cell, i) {
                    cell.innerHTML = '<div class="form-checkbox">\
						<input class="check js-checkbox-ref" type="checkbox" name="check">\
						<label for="checkboxRef" tabindex="1"></label>\
				  	</div>';
                });

            })
                .on('order.dt', function () {
                    let customerCatalogFiltreddatas = $(ACC.datatables.customerCatalogID).dataTable().api().order();
                    localStorage.setItem('customerCatalogFiltreddatas', '&columnIndex=' + customerCatalogFiltreddatas[0][0] + '&sortDirection=' + customerCatalogFiltreddatas[0][1]);
                })
            ACC.datatables.getCurrentPage(ACC.datatables.customerCatalogID);
        }

        $(document).on('click', ".js-btn-edit-ref:not(.disabled)", function () {
            let _this = $(this),
                container = _this.closest("tr"),
                refText = container.find('.ref-text'),
                inputElement = container.find('.edit-ref-input'),
                saveBtn = container.find('.save-ref-btn'),
                newText = inputElement.val().trim();

            UI().init();
            inputElement.val(inputElement.data('old')).removeClass('hidden').focus();// copy data and display the input
            UI().edit(container, refText);
        })
            .on('click', '.save-ref-btn:not(.hasError)', function (e) {
                let _this = $(this),
                    container = _this.closest("tr"),
                    input = container.find('.edit-ref-input'),
                    inputElementValue = input.val().trim(),
                    refText = container.find('.ref-text'),
                    productCode = _this.attr('id'),
                    saveBtn = _this;

                if (inputElementValue.length > 35) {
                    UI().showError(container, _this, refText, 'max-char-error');
                } else {
                    UI().hideError(container, _this);
                    // update data if null set the default value otherwise set the new val !
                    _this.data('old', inputElementValue).addClass('hidden')
                    refText.text(inputElementValue).data('old', inputElementValue).removeClass('hidden');

                    //check if the ref is already exesting !
                    if (inputElementValue.length > 0) {

                        let isExistingRef = ACC.datatables._customerCatalogProducts.filter(o => (o.productReference == inputElementValue))

                        if (isExistingRef.length > 0 && isExistingRef[0].productCode !== productCode) {
                            UI().hideError(container, _this);
                            UI().showError(container, _this, refText, 'unique-error')
                        } else {
                            UI().hideError(container, _this);
                            //recheck before add
                            let isExistingWithSameRef = ACC.datatables.tableRefUpdated.filter(o => (o.productCode == productCode))
                            if (isExistingWithSameRef.length === 0) {
                                let _ = ACC.datatables.tableRefUpdated.filter(o => (o.productCode == productCode || o.productReference == inputElementValue));
                                if (_.length !== 0) {
                                    UI().showError(container, _this, refText, 'unique-error')

                                } else {
                                    ACC.datatables.tableRefUpdated.push({
                                        productCode: productCode,
                                        productName: '',
                                        productReference: inputElementValue
                                    });
                                }
                            } else {
                                //update ref or remove is with same values
                                const index = ACC.datatables.tableRefUpdated.findIndex(o => o.productCode === productCode);
                                ACC.datatables.tableRefUpdated[index].productReference = inputElementValue;
                            }
                        }

                        const _obj = ACC.datatables.tableRefUpdated.filter(o => o.productCode);
                        if (_obj.length > 0) {
                            sendDataToServer(_obj[0].productReference, _obj[0].productCode, container, input, refText, saveBtn)
                        }
                    } else {
                        // case
                        ACC.datatables.tableRefUpdated = ACC.datatables.tableRefUpdated.filter((o) => o.productCode !== productCode);
                        sendDataToServer('', productCode, container, input, refText, saveBtn)
                        container.find('.js-btn-edit-ref').removeClass('hidden');
                    }

                }
            })
            .on('keypress', '.edit-ref-input:not(.mobile)', function (e) {
                if (e.which == 13) {
                    let _this = $(this),
                        btnSave = _this.closest('tr').find('.save-ref-btn');
                    _this.blur();
                    btnSave.trigger('click');
                }
            })
            .on('focusout', '.edit-ref-input:not(.mobile)', function (event) {

                let _this = $(this),
                    container = _this.closest("tr"),
                    inputElementValue = _this.val().trim(),
                    refText = container.find('.ref-text'),
                    btnSave = container.find('.save-ref-btn'),
                    productCode = btnSave.attr('id');

                _this.data('old', refText.text());
                UI().hideError(container, _this);

                if (inputElementValue == refText.text() && inputElementValue == '') {
                    UI().init();
                } else {
                    if (inputElementValue.length > 35) {
                        UI().showError(container, _this, refText, 'max-char-error');
                    } else if (inputElementValue.length > 0) {
                        if (inputElementValue.length > 0 && inputElementValue != _this.data('old')) {
                            let isExistingRef = ACC.datatables._customerCatalogProducts.filter(o => (o.productReference == inputElementValue)),
                                isExistingProductWithSameRef = ACC.datatables._customerCatalogProducts.filter(o => (o.productReference == inputElementValue && o.productCode == productCode));

                            if (isExistingProductWithSameRef.length > 0) {
                                UI().showError(container, _this, refText, 'unique-error');
                            } else if (isExistingRef.length > 0 && isExistingRef[0].productCode !== productCode && isExistingProductWithSameRef.length == 0) {
                                UI().showError(container, _this, refText, 'unique-error');
                                btnSave.removeClass('hidden');
                                _this.removeClass('hidden');
                                refText.addClass('hidden');
                                UI().showError(container, _this, refText, 'unique-error');


                            } else {
                                UI().edit(container, refText);
                                let isExistingRef = ACC.datatables.tableRefUpdated.filter(o => (o.productReference == inputElementValue))
                                if (isExistingRef.length === 0) {
                                    ACC.datatables.tableRefUpdated.push({
                                        productCode: productCode,
                                        productName: '',
                                        productReference: inputElementValue
                                    });
                                } else {
                                    UI().showError(container, _this, refText, 'unique-error')
                                }
                            }

                        } else {
                            //same datas
                            UI().init()
                        }
                    } else {
                        container.find('.ref-text').text('').data('old', '').removeClass('hidden');
                        btnSave.removeClass('hidden');
                        _this.removeClass('hidden');
                    }
                }

            });

        function sendDataToServer(productReference, productCode, container, input, refText, saveBtn) {
            //keep input visible + save btn
            ACC.datatables.AJAX_CALL_FINISHED = false;
            container.find('.loader').removeClass('hidden');
            refText.addClass('hidden');
            $.ajax({
                url: ACC.config.encodedContextPath + "/customer-reference/update",
                type: 'POST',
                data: {
                    productReference: productReference,
                    productCode: productCode,
                    CSRFToken: ACC.config.CSRFToken
                },
                datatype: 'json',
                success: function (data) {
                    ACC.datatables.AJAX_CALL_FINISHED = true;
                    if (data[0].isReferenceUpdated) {
                        container.find('.loader').addClass('hidden');
                        UI().init();
                        input.data('old', productReference).addClass('hidden');
                        UI().status('saved');
                        ACC.datatables._customerCatalogProducts.map(e => {
                            e.productCode === productCode;
                            e.productReference = productReference
                        })
                    } else {
                        ACC.colorbox.open(title = "", {
                            href: "#errorWsRefCatalog",
                            inline: true,
                            width: "600px",
                            height: "400px",
                            onComplete: function () {
                                $(".js-btn-redirect-ws").on("click", function () {
                                    container.find('.loader').addClass('hidden');
                                    refText.addClass('hidden');
                                    saveBtn.removeClass('hidden');
                                    ACC.colorbox.close();
                                });
                            },
                        });
                        ACC.datatables.savingStatus = false;
                    }
                }
            })
        }


        function UI() {

            const _editBtn = $('.js-btn-edit-ref');

            _status: function _status(status) {
                if (status === 'saved') {
                    $(".color-status").addClass("green");
                    $(".status-saving .text-status").addClass("hidden");
                    $(".status-saving .text-status.saved").removeClass("hidden");
                    ACC.datatables.savingStatus = true;
                } else {
                    $(".color-status").removeClass("green");
                    $(".status-saving .text-status").addClass("hidden");
                    $(".status-saving .text-status.not-saving").removeClass("hidden");
                    ACC.datatables.savingStatus = false;
                }
            }

            _init: function _init() {
                $('.save-ref-btn, .edit-ref-input').addClass('hidden');
                $('.js-btn-edit-ref, .ref-text').removeClass('hidden');
                ACC.datatables.tableRefUpdated = [];
                $(".color-status").addClass("green");
                $(".status-saving .text-status").addClass("hidden");
                $(".status-saving .text-status.saved").removeClass("hidden");
                ACC.datatables.savingStatus = true;
            }

            _reset: function _reset(container) {
                $('.save-ref-btn, .edit-ref-input').addClass('hidden');
                $('.js-btn-edit-ref, .ref-text').removeClass('hidden');
                _status('saved')
            }

            _editMode: function _editMode(container, refText) {
                _editBtn.addClass('disabled');
                container.find('.edit-ref-input, .save-ref-btn').removeClass('hidden');
                container.find('.js-btn-edit-ref').addClass('hidden');// hide save button
                container.find('.save-ref-btn').removeClass('hidden');
                refText.addClass('hidden');
                _status('edit')
            }


            _showError: function _showError(container, input, refText, type) {
                ACC.datatables.hasErrors = true;
                if (type) {
                    container.addClass('errors').find('.ref-errors').removeClass('hidden').find('.ref-error.' + type).removeClass('hidden');
                }
                refText.addClass('hidden')
                container.find('.save-ref-btn').addClass('hasError');
                input.removeClass('hidden').end().addClass('error').focus();
                container.find('.js-btn-edit-ref').addClass('hidden');//ok
                _editBtn.addClass('disabled');

            }

            _hideError:  function _hideError(container, input) {
                ACC.datatables.hasErrors = false;
                container.removeClass('errors').find('.ref-errors').addClass('hidden').find('.ref-error').addClass('hidden');
                input.addClass('hidden').removeClass('error');
                if (ACC.datatables.AJAX_CALL_FINISHED) {
                    _editBtn.removeClass('disabled');
                }
                container.find('.save-ref-btn').removeClass('hasError');

            }

            return {
                init: _init,
                reset: _reset,
                edit: _editMode,
                showError: _showError,
                hideError: _hideError,
                status: _status
            }
        }

    },
};
